import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtNum } from "@/lib/api";
import { Empty, Spinner } from "@/components/Brand";
import { PageTitle } from "@/pages/admin/AdminLayout";

export default function StatsAdmin() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/stats/packages").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  if (!rows) return <Spinner />;
  return (
    <div>
      <PageTitle title="Statistik Peserta" desc="Statistik per paket dari hasil ujian yang sudah selesai." />
      {rows.length === 0 ? <Empty text="Belum ada paket." /> : (
        <div className="grid gap-4 lg:grid-cols-2">
          {rows.map((p) => (
            <div key={p.id} className="card-premium p-5" data-testid={`stats-package-${p.id}`}>
              <h3 className="font-display text-lg font-bold text-[#0A192F]">{p.name}</h3>
              <div className="mt-3 grid grid-cols-3 gap-3 text-center text-sm sm:grid-cols-6">
                {[["Percobaan", p.attempts], ["Peserta", p.participants], ["Rata-rata", fmtNum(p.average)], ["Tertinggi", fmtNum(p.highest)], ["Terendah", fmtNum(p.lowest)], ["Lulus", p.pass_rate == null ? "-" : `${fmtNum(p.pass_rate)}%`]].map(([l, v]) => (
                  <div key={l} className="rounded-lg bg-slate-50 p-2"><div className="text-[10px] font-bold uppercase text-slate-400">{l}</div><div className="font-bold text-[#0A192F]">{v}</div></div>
                ))}
              </div>
              {p.subjects.length > 0 && (
                <div className="mt-4 space-y-2">
                  {p.subjects.map((s) => (
                    <div key={s.name} className="text-xs">
                      <div className="flex justify-between"><span>{s.name}</span><b>{fmtNum(s.average)}/{fmtNum(s.max_score)}</b></div>
                      <div className="mt-1 h-2 rounded bg-slate-100"><div className="h-2 rounded bg-amber-500" style={{ width: `${s.max_score ? Math.min(100, (s.average / s.max_score) * 100) : 0}%` }} /></div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
